import React from 'react';

import Bracket from './Bracket';
import JsonLogicBuilder from './index';
import Divider from './Divider';
import Delete from './Delete';

const operators = [
  {value: '!', label: 'Was not answered'},
  {value: '!!', label: 'Was answered'}
];

function ValidationExpression({variables, operator, value, onChange, onCollapse}) {
  return (
    <Bracket onCollapse={onCollapse}>
      <JsonLogicBuilder
        expand
        variables={variables}
        value={value[0]}
        onChange={nextValue => onChange({[operator]: [nextValue]})}
      />
      <Divider />
      <LogicSelector
        value={operator}
        onChange={nextOperator => onChange({[nextOperator]: value})}
      />
      <Delete onClick={() => onChange(null)} />
    </Bracket>
  );
}

function LogicSelector({value, onChange}) {
  return (
    <select value={value} onChange={e => onChange(e.target.value)}>
      {operators.map(operator => (
        <option key={operator.value} value={operator.value}>
          {operator.label}
        </option>
      ))}
    </select>
  );
}

export default ValidationExpression;
